import FavoritesSection from './FavoritesSection';
export default FavoritesSection;
